import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

import { CallEvent } from "../../shared/types";

@Component({
	selector: "call-event-item",
	templateUrl: "call-event-item.component.html",
	styleUrls: ["call-event-item.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CallEventItemComponent {
	// @ts-expect-error TS2564
	@Input() callEvent: CallEvent;
	@Input() alarmsPermission = true;

	get suggestions() {
		const names = [];
		for (const suggestion of this.callEvent.suggestions) {
			names.push(suggestion.firstName);
		}

		return names.join(", ");
	}
}
